/**
 * This mixin only works with router-views that contains a scope, entity and
 * portal ("/scope/entity/portal"), it was created to work with the sidebar menu.
 */
import axios from 'axios';

export default {
  methods: {
    async setPortalFiltersToRoute(route) {
      try {
        if (this.portalEntity) {
          let { criterias } = (await axios.get(`Portal/${this.portalEntity.id}?load[]=Criterias`, {
            _Entity: 'Portal',
          })).data;
          if (criterias && criterias.length > 0) {
            const hasLogOperatorRegex = /^&&|^\|\|/;
            let isFirst = true;
            let reducedCriterias = _.reduce(criterias, (res, { translatedValue }) => {
              //  Check if starts with && or || and ignore it like this, else append &&
              if (!translatedValue) return res;
              if (isFirst) {
                isFirst = false;
                return `${translatedValue}`
              }
              if (hasLogOperatorRegex.test(translatedValue)) return `${res} ${translatedValue}`;
              return `${res} && ${translatedValue}`;
            }, "");
            const prevWheres = route.params.hiddenCriteria || "";
            route.params.hiddenCriteria = `${prevWheres} ${prevWheres ? '&&' : ''} ${reducedCriterias}`;
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    portal() {
      return this.$store.state.portal;
    },
    portalFilters() {
      const rules = this.portalEntity ? (this.portalEntity.rules || []) : [];
      return rules.map(r => r.expression);
    },
    portalEntity() {
      return this.$searchEntity(this.portal, 'name');
    },
    headersFormatted() {
      return this.$overrideFields(
        this.headers,
        this.$fields(this.portalEntity, 'primitive'),
        ['alias', 'value', 'text'],
      );
    },
  },
  beforeCreate() {
    // If the user reloads in the index and it's a portal route, we need to set
    // the portal template in the vuex storage to have a normal behavior.
    if (!this.portal && this.$route.params.portal) {
      this.$store.commit('SET_PORTAL_TEMPLATE', this.$route.params.portal);
    }
  }
};
